import get from 'lodash/get';
import { useQuery } from 'react-query';

import config from 'config';

import { getMeta } from 'helpers/mappers';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useList = ({ params }) => {
  const initialData = { items: [], meta: getMeta() };

  const paramsWithDefaults = {
    page: params?.page ? params.page - 1 : 0,
    perPage: params?.perPage || config.perPage,
    sort: {
      name: params?.sort?.name || 'createdAt',
      direction: params?.sort?.direction || 'desc'
    },
    filter: (params?.filter || []).filter(i => !!i.value)
  };  

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'list', paramsWithDefaults.page, paramsWithDefaults.perPage, params.search],
    async () => {
      const { data } = await Api.List({
        params: paramsWithDefaults
      });

      const items = (get(data, 'data') || []).map(item => Mappers.FunctionRegister(item));

      const meta = getMeta(data);

      return { items, meta };
    },
    { initialData, keepPreviousData: true }
  );

  return { ...data, ...args };
};

export default useList;
